import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

/**
 * Some URL parameters are encoded strings.
 *
 * Use this hook instead of useParams to get values
 * that are not decoded.
 */
export const useEncodedParams = () => {
  const params = useParams()

  const reencodedParams = useMemo(
    () =>
      Object.entries(params).reduce(
        (prev, [key, value]) => ({
          ...prev,
          [key]: encodeURIComponent(value!),
        }),
        {},
      ),
    [params],
  )

  return reencodedParams as typeof params
}
